// /* eslint-disable react-hooks/exhaustive-deps */
// import { useQuery } from '@apollo/client';
// import CardWithTitle from 'components/CardWithTitle';
// import {
//   OrderCountsByStatus,
//   OrderCountsByStatusSubscription,
// } from 'pages/Dashboard/components/DashboardGraphQL';
// import React, { useEffect } from 'react';
// import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
// import { Doughnut } from 'react-chartjs-2';
// import { Col, Row } from 'reactstrap';
// import { orderStatusColors, orderStatusLabel } from 'utils/constants';
// import Loader from 'components/common/Loader';
// import { isEmpty } from 'lodash';

// ChartJS.register(ArcElement, Tooltip, Legend);

// const OrderStatusChart = () => {
//   const { data, loading, error, subscribeToMore } = useQuery(
//     OrderCountsByStatus,
//     {
//       fetchPolicy: 'network-only',
//     },
//   );

//   const getStatusLabel = (status) => orderStatusLabel[status] || status;

//   const getStatusBgColor = (status) => orderStatusColors[status] || '#000';

//   const showStatus = ({ status, percent, count }) => (
//     <tr key={status}>
//       <td className="pe-2">
//         <span
//           style={{ backgroundColor: getStatusBgColor(status) }}
//           className="order-status rounded-circle me-2"
//         />
//         {getStatusLabel(status)}
//       </td>
//       <td className="pe-2 text-black-696">{percent}%</td>
//       <td>{count}</td>
//     </tr>
//   );

//   const statusData = {
//     datasets: [
//       {
//         data: data?.orderCountsByStatus?.map(({ count }) => count),
//         backgroundColor: data?.orderCountsByStatus?.map(({ status }) =>
//           getStatusBgColor(status),
//         ),
//         cutout: '80%',
//         borderColor: data?.orderCountsByStatus?.map(({ status }) =>
//           getStatusBgColor(status),
//         ),
//       },
//     ],
//   };

//   useEffect(() => {
//     const unsubscribe = subscribeToMore({
//       document: OrderCountsByStatusSubscription,

//       updateQuery: (prev, { subscriptionData }) => {
//         if (!prev || isEmpty(prev)) return '';
//         if (!subscriptionData.data) return prev;
//         return subscriptionData.data;
//       },
//     });
//     return () => unsubscribe();
//   }, []);

//   if (error) return `There is an error on this page : ${error.message} `;

//   return (
//     <CardWithTitle className="card-box h-100 pb-3" title="Order Status">
//       {loading ? (
//         <Loader />
//       ) : (
//         <Row className="align-items-sm-center mt-3 justify-content-center">
//           <Col sm={12}>
//             <Row className="justify-content-center">
//               <Col sm={7} xl={7} xxl={5}>
//                 {' '}
//                 <Doughnut data={statusData} />
//               </Col>
//             </Row>
//           </Col>
//           <Col
//             sm={8}
//             md={10}
//             lg={7}
//             xxl={5}
//             className="order-status-list mt-5 mt-xxl-4"
//           >
//             <div className="px-4">
//               <table className="w-100 m-auto">
//                 <tbody>
//                   {data?.orderCountsByStatus?.map((item) => showStatus(item))}
//                 </tbody>
//               </table>
//             </div>
//           </Col>
//         </Row>
//       )}
//     </CardWithTitle>
//   );
// };

// export default OrderStatusChart;

/* eslint-disable react-hooks/exhaustive-deps */
import { useQuery } from '@apollo/client';
import CardWithTitle from 'components/CardWithTitle';
import {
  OrderCountsByStatus,
  OrderCountsByStatusSubscription,
} from 'pages/Dashboard/components/DashboardGraphQL';
import React, { useEffect } from 'react';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import { Doughnut } from 'react-chartjs-2';
import { Col, Row } from 'reactstrap';
import { orderStatusColors, orderStatusLabel } from 'utils/constants';
import Loader from 'components/common/Loader';
import { isEmpty } from 'lodash';

ChartJS.register(ArcElement, Tooltip, Legend);

const OrderStatusChart = () => {
  const { data, loading, error, subscribeToMore } = useQuery(
    OrderCountsByStatus,
    {
      fetchPolicy: 'network-only',
    },
  );

  const getStatusLabel = (status) => orderStatusLabel[status] || status;

  const getStatusBgColor = (status) => orderStatusColors[status] || '#000';

  const showStatus = ({ status, percent, count }) => (
    <tr key={status}>
      <td className="pe-2">
        <span
          style={{ backgroundColor: getStatusBgColor(status) }}
          className="order-status rounded-circle me-2"
        />
        {getStatusLabel(status)}
      </td>
      <td className="pe-2 text-black-696">{percent}%</td>
      <td>{count}</td>
    </tr>
  );

  const statusData = {
    datasets: [
      {
        data: data?.orderCountsByStatus?.map(({ count }) => count),
        backgroundColor: data?.orderCountsByStatus?.map(({ status }) =>
          getStatusBgColor(status),
        ),
        cutout: '80%',
        borderColor: data?.orderCountsByStatus?.map(({ status }) =>
          getStatusBgColor(status),
        ),
      },
    ],
  };

  useEffect(() => {
    const unsubscribe = subscribeToMore({
      document: OrderCountsByStatusSubscription,

      updateQuery: (prev, { subscriptionData }) => {
        if (!prev || isEmpty(prev)) return '';
        if (!subscriptionData.data) return prev;
        return subscriptionData.data;
      },
    });
    return () => unsubscribe();
  }, []);

  if (error) return `There is an error on this page : ${error.message} `;

  return (
    <CardWithTitle className="card-box h-100 pb-3" title="Order Status">
      {loading ? (
        <Loader />
      ) : (
        <Row className="align-items-center mt-3 justify-content-center">
          <Col
            sm={12}
            md={6}
            lg={5}
            xl={4}
            className="d-flex justify-content-center"
          >
            <div style={{ maxWidth: '300px', width: '100%' }}>
              <Doughnut data={statusData} />
            </div>
          </Col>
          <Col
            sm={12}
            md={6}
            lg={5}
            xl={4}
            className="order-status-list mt-4 mt-md-0"
          >
            <div className="px-4">
              <table className="w-100 m-auto">
                <tbody>
                  {data?.orderCountsByStatus?.map((item) => showStatus(item))}
                </tbody>
              </table>
            </div>
          </Col>
        </Row>
      )}
    </CardWithTitle>
  );
};

export default OrderStatusChart;
